import { Store, StoreOptions } from 'vuex';

import { getProfile } from '@/Api/auth';

export interface AuthInformation {
    id: 1;
    username: string;
    cid: number;
    email: string;
    mobile: string;
    nickname: string;
    company: string;
    description: string;
    is_staff: true;
}
type Subset<T> = Partial<T>;

/**
 * @author guan
 * @description 用户认证信息
 *
 */
const authMessage: StoreOptions<{ [key in string]: any }> = {
    state: {
        token: '',
        userInfo: {},
    },
    getters: {
        /**
         * @author guan
         * @description 获取token
         * @return  返回token信息
         */
        getToken: (state): string => {
            return state.token;
        },
        /**
         *
         * @author  yms
         * @description 获取用户信息
         * @returns 返回用户信息的子集
         */
        getUserInfo: (state): Subset<AuthInformation> => {
            return state.userInfo;
        },
    },
    mutations: {
        /**
         * @author yms
         * @description 设置token
         * @param v token 值
         */
        setToken: (state, v: string): void => {
            state.token = v;
        },
        /**
         * @author yms
         * @description 设置userInfo
         * @param  Subset<AuthInformation>
         */
        setUserInfo: (state, v: Subset<AuthInformation>): void => {
            state.userInfo = v;
        },
    },
    actions: {
        /**
         * @author yms
         * @param context store
         * @description 获取用户信息
         */
        putUserInfo: (context): Promise<void> => {
            return new Promise((resolve, reject) => {
                getProfile()
                    .then((res) => {
                        context.commit('setUserInfo', res);
                        resolve();
                    })
                    .catch((e) => {
                        reject(e);
                    });
            });
        },
    },
};
export default authMessage;
